export const GET_TEMPORARY_UPLOAD_CREDENTIALS_SUCCESS = 'GET_TEMPORARY_UPLOAD_CREDENTIALS_SUCCESS';

export const GET_TEMPORARY_UPLOAD_CREDENTIALS_FAIL = 'GET_TEMPORARY_UPLOAD_CREDENTIALS_FAIL';